
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/rootComps/helpHome/blocks/actionItem.scss.css.virtualfile';
        module.exports = {"helpHomeActionItem":"_helpHomeActionItem_1rfqo_7"};